import { Content, Footer, Header, RouterContext } from '../../gs-component-right-rail';
import { Button } from '@xo-union/tk-component-buttons';
import { FormBlockColumn } from '@xo-union/tk-component-form-grid';
import { FormikProps } from 'formik';
import React, { Fragment, useContext } from 'react';

import { CustomVendorFields } from '../components/Form/CustomVendorFields';
import { LocationContext } from '../components/LocationContext';
import RightRailSection from '../components/RightRailSection';
import hasAddress from '../helpers/addressHelpers';
import { resetVendorLocation } from '../helpers/formHelpers';
import { FormValues } from './RightRailForm';

interface Props {
  params?: {
    eventIndex?: number;
    eventType?: string;
  };
  formProps: FormikProps<FormValues>;
}

export const AddCustomVendor: React.FC<Props> = ({ params: { eventIndex, eventType } = {}, formProps }) => {
  const { goBack, push, previousView } = useContext(RouterContext);
  const { setCeremonyAddress, setReceptionAddress, location } = useContext(LocationContext);

  const navigateBack = (): void => {
    if (previousView === 'subEvent') {
      push({ screen: 'subEvent', params: { eventIndex, eventType } });
    } else {
      goBack();
    }
  };

  const addCustomVendor = (): void => {
    if (eventType === 'Ceremony') {
      if (!hasAddress(formProps.values.events[0].location)) {
        return navigateBack();
      }

      const { city, country, name, state, street1, zip } = formProps.values.events[0].location;
      setCeremonyAddress(
        {
          id: location.CER && location.CER.id,
          vendor_name: name,
          address_components: {
            user_entry: {
              street: street1,
              city,
              postal_code: zip,
              state,
              country,
            },
          },
        },
        formProps.values.events[0].sameVenue
      );
    } else if (eventType === 'Reception') {
      if (!hasAddress(formProps.values.events[1].location)) {
        return navigateBack();
      }

      const { city, country, name, state, street1, zip } = formProps.values.events[1].location;
      setReceptionAddress({
        id: location.REC && location.REC.id,
        vendor_name: name,
        address_components: {
          user_entry: {
            street: street1,
            city,
            postal_code: zip,
            state,
            country,
          },
        },
      });
    }
    navigateBack();
  };

  const resetAndGoBack = (): void => {
    const { initialValues, setFieldValue } = formProps;
    resetVendorLocation(setFieldValue, eventIndex, initialValues);
    navigateBack();
  };

  return (
    <Fragment>
      <Header leftButtonText="Back" leftButtonOnClick={resetAndGoBack}>
        Add Custom Vendor
      </Header>
      <Content>
        <RightRailSection name="Vendor Information">
          <FormBlockColumn>
            <CustomVendorFields namePrefix={`events[${eventIndex}].`} />
          </FormBlockColumn>
        </RightRailSection>
      </Content>
      <Footer>
        <Button block type="button" onClick={addCustomVendor}>
          Done
        </Button>
      </Footer>
    </Fragment>
  );
};
